@let color = product().data.sale_banner | optionColor : 'sale_banner';
<div class="w-12-s w-12-m center p-a-2 p-a-1-s p-a-1-m m-b-3 s2"
     [class.ng-hide]="!canShow()"
     [class.w-12]="fullWidth()"
     [class]="content().sale_banner_font_color || ''"
     [style]="{'background-color': color}"
     [bgContrast]="color">
    <div class="inline-flex"
         [style.gap.px]="2">
        {{product().data.sale_banner | optionLabel : 'sale_banner'}}
        @if (label()?.endDate) {
        &thinsp;-&nbsp;
        }
    </div>
    @if (label()?.endDate) {
    <countdown [date]="label().endDate"
               [shouldPad]="true"
               (isActive)="handleIsActive($event)">
        <ng-template #countdownTemplate
                     let-result>
            <!-- content during countdown -->
            @if (result.score?.days || result.score?.hours || result.score?.minutes || result.score?.seconds) {
            <div class="inline-flex"
                 [style.gap.px]="2">
                <!-- countdown -->
                @if (result.score?.seconds) {
                @if (label().copy) {
                {{label().copy}}
                }
                @if (result.score?.days > 10) {
                <span>{{result.score.days}}{{'d' | translate}}&nbsp;:&nbsp;</span>
                } @else if (result.score?.days === 0) {
                <span>00{{'d' | translate}}&nbsp;:&nbsp;</span>
                } @else {
                <span>0{{result.score.days}}{{'d' | translate}}&nbsp;:&nbsp;</span>
                }
                <span>{{result.score?.hours}}{{'h' | translate}}&nbsp;:&nbsp;</span>
                <span>{{result.score?.minutes}}{{'m' | translate}}</span>
                }
            </div>
            }
        </ng-template>
    </countdown>
    }
</div>